import PropTypes from 'prop-types';
import React, { Component } from "react";
import MasonryComponent from "react-masonry-component"
import {debounce} from "lodash/function"

export default class Masonry extends Component {

  static propTypes = {
    elementType: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.node)
  }

  static defaultProps = {
    elementType: "article",
  }

  render() {
    const {elementType, children} = this.props

    return (
      <MasonryComponent
        key="masonry"
        // percentPosition
        elementType={elementType}
        ref={(c) => { if (c) this.masonry = c.masonry }}
      >
          {children}
      </MasonryComponent>
    )
  }

  masonryLayout = debounce(() => {
    if (this.masonry) {
      this.masonry.layout();
    }
  }, 500)
}



// WEBPACK FOOTER //
// ./webapp/components/elements/Masonry.js